module.exports = __webpack_public_path__ + "img/logo-ccr3-blue.63565b5d.svg";